// breadcrumbSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  breadcrumbPaths: [] // stores breadcrumb objects like { path: "/some/path", state: ... }
};

const breadcrumbSlice = createSlice({
  name: 'breadcrumb',
  initialState,
  reducers: {
    addBreadcrumb: (state, action) => {
      const exists = state.breadcrumbPaths.some(
        (crumb) => crumb.path === action.payload.path
      );
      if (!exists) {
        state.breadcrumbPaths.push(action.payload);
      }
    },
    resetBreadcrumb: (state) => {
      state.breadcrumbPaths = []; // Clear the breadcrumb path
    },
    truncateBreadcrumb: (state, action) => {
      const index = state.breadcrumbPaths.findIndex(
        (crumb) => crumb.path === action.payload
      );
      if (index !== -1) {
        state.breadcrumbPaths = state.breadcrumbPaths.slice(0, index + 1);
      }
    }
  }
});

export const { addBreadcrumb, resetBreadcrumb, truncateBreadcrumb } = breadcrumbSlice.actions;
export default breadcrumbSlice;
